import { useQueryData } from "@src/hooks/useQueryData";
import { wsInvActsServices, type WsInvActExtends } from "../../../../../api/wsInvActs";

/** Связи заголовка АИ, нужные UI карточки. */
export const WS_INV_ACT_CARD_INCLUDES = {
    include: ["Division", "DivisionSection", "Bo"] satisfies Array<keyof WsInvActExtends>,
    includeBo: ["State"] satisfies Array<"State">,
} as const;

/**
 * Загрузка карточки АИ (только данные; права — через {@link useBoRights}).
 */
export function useWsInvActCardQuery(actCode: number) {
    return useQueryData({
        queryKey: ["workshop", "wsInvAct", actCode, "card"],
        queryFn: async ({ signal }) => {
            const act = await wsInvActsServices.loadOne(
                {
                    flt: { Codes: [actCode] },
                    ...WS_INV_ACT_CARD_INCLUDES,
                },
                { signal },
            );

            if (act == null) {
                throw new Error("Ошибка в получении данных о АИ");
            }

            return act;
        },
        enabled: actCode > 0,
        meta: { errorSource: "workshop.wsInvAct.card" },
    });
}
